var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import { ExpiryDateComponent } from "./components/expiry-date";
import { CvvComponent } from "./components/cvv-component";
import { useState } from "react";
import { CardNumberComponent } from "./components/cardnumber-component";
import { useTranslation } from "react-i18next";
export var CardControlMui = function (_a) {
    var formik = _a.formik;
    var _b = useState(), cardType = _b[0], setCardType = _b[1];
    var _c = useTranslation(), t = _c.t, i18n = _c.i18n;
    return (_jsxs(_Fragment, { children: [_jsx(Typography, __assign({ variant: "subtitle1", noWrap: true, component: "div" }, { children: t("Card Information") })), _jsx("br", {}), _jsx(Grid, __assign({ container: true, spacing: 2 }, { children: _jsx(Grid, __assign({ item: true, xs: 6, sx: { minWidth: 300, padding: 2 } }, { children: _jsx(CardNumberComponent, { setCardType: setCardType, formik: formik, cardType: cardType }) })) })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 3, sx: { minWidth: 150, padding: 2 } }, { children: _jsx(ExpiryDateComponent, { formik: formik }) })), _jsx(Grid, __assign({ item: true, xs: 3, sx: { minWidth: 150, padding: 2 } }, { children: _jsx(CvvComponent, { formik: formik, cardType: cardType }) }))] }))] }));
};
